<div [formGroup]="formGroup" class="space-y-1">
    <!-- Date Range Input -->
    <div class="w-full">
        @if(slot.label){
            <label class="block text-[14px] font-medium text-foreground opacity-80 mb-2">
                {{ slot.label }}
            </label>
        }
        <app-date-range-picker
            (click)="$event.stopPropagation()"
            [startValue]="getStartValue()"
            [endValue]="getEndValue()"
            [showLabel]="false"
            (startDateChange)="onStartDateChange($event)"
            (endDateChange)="onEndDateChange($event)"
        ></app-date-range-picker>
    </div>

    <!-- Time Inputs -->
    <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
            <label for="start-time" class="font-medium mb-1">{{ 'common.date-selection.startTime' | transloco }}</label>
            <ngx-timepicker-field 
                class="w-full border-none shadow-none rounded-lg p-2 focus:ring-2 focus:ring-indigo-500 transition appearance-none"
                [formControlName]="startTimeField" 
                [format]="'HH:mm'" 
                id="start-time">
            </ngx-timepicker-field>
        </div>
        <div class="flex flex-col gap-2 mb-4">
            <label for="end-time" class="font-medium mb-1">{{ 'common.date-selection.endTime' | transloco }}</label>
            <ngx-timepicker-field 
                class="w-full border-none shadow-none rounded-lg p-2 focus:ring-2 focus:ring-indigo-500 transition appearance-none"
                [formControlName]="endTimeField" 
                [format]="'HH:mm'" 
                id="end-time">
            </ngx-timepicker-field>
        </div>
    </div>
</div>
